/** Сведения о демо-версии: заполняет только сборка демо, в обычном приложении их нет. */
export interface DemoInfo {
  /** Логин и пароль, которыми можно войти после «Выйти». */
  readonly email: string;
  readonly password: string;
  /** Размеры встречи, которые можно показать одним нажатием. */
  readonly meetings: readonly number[];
  readonly showMeeting: (count: number) => void;
  /** Письма, которые «отправил» демо-сервер (приглашения): почты в демо нет, их открывают на странице входа. */
  readonly letters?: () => readonly DemoLetter[];
  /** Тарифы в демо: посмотреть продукт на Free, Pro и Enterprise, в облаке и в коробке, в разных состояниях оплаты. */
  readonly plans?: DemoPlans;
}

export type DemoPlan = "free" | "pro" | "enterprise";
export type DemoDeployment = "cloud" | "onprem";
export type DemoBillingState = "active" | "renewSoon" | "overLimit" | "expired";

export interface DemoPlanState {
  readonly plan: DemoPlan;
  readonly deployment: DemoDeployment;
  readonly state: DemoBillingState;
}

export interface DemoPlans {
  readonly current: () => DemoPlanState;
  /** Сменить и сохранить до конца вкладки; интерфейс сам перечитает пространство. */
  readonly change: (next: Partial<DemoPlanState>) => void;
  /** «Обновить ключ» в коробке: текст ошибки или null — ключ принят. */
  readonly applyKey: (key: string) => string | null;
}

export interface DemoLetter {
  readonly to: string;
  readonly toName: string;
  readonly subject: string;
  readonly text: string;
  /** Ссылка из письма: #/join/<token>. */
  readonly link: string;
  /** Приглашение ещё можно принять. */
  readonly active: boolean;
}

let info: DemoInfo | null = null;

export function setDemoInfo(value: DemoInfo | null): void {
  info = value;
}

export function demoInfo(): DemoInfo | null {
  return info;
}
